'use strict';

var _require = require('./constants'),
    FILE_SEPARATOR = _require.FILE_SEPARATOR;

var IPFS_PREFIX = '/ipfs';

var validatePath = function validatePath(path, callback) {
  path = (path || '').trim();

  if (!path) {
    return callback(new Error('paths must not be empty'));
  }

  if (path.substring(0, 1) !== FILE_SEPARATOR) {
    return callback(new Error("paths must start with a leading ".concat(FILE_SEPARATOR)));
  }

  if (path.substring(path.length - FILE_SEPARATOR.length) === FILE_SEPARATOR) {
    path = path.substring(0, path.length - FILE_SEPARATOR.length);
  }

  var parts = path.split(FILE_SEPARATOR).filter(Boolean);
  var name = parts.pop();
  var directory = "".concat(FILE_SEPARATOR).concat(parts.join(FILE_SEPARATOR));

  if (path.substring(0, IPFS_PREFIX.length) === IPFS_PREFIX) {
    return callback(null, {
      type: 'ipfs',
      path: path.substring(IPFS_PREFIX.length + 1),
      directory: directory,
      name: name
    });
  }

  callback(null, {
    type: 'mfs',
    path: path || FILE_SEPARATOR,
    directory: directory,
    name: name
  });
};

module.exports = validatePath;